import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import AnimatedLoadingSVG from '../../assets/svgs/AnimatedLoadingSVG';

function LoadingPage(
    props: {
        loading: boolean,
        initialLink: string
    }
) {

    const loading = props.loading;
    const initialLink = props.initialLink;

    const navigate = useNavigate();

    useEffect(() => {

        if(loading === false) {
            navigate(initialLink);
        }

    }, [loading])

  return (
    <div className='w-full h-full
                   flex items-center justify-center'>
        <div className='w-[100px] h-[100px]'>
            <AnimatedLoadingSVG />
        </div>
    </div>
  )
}

export default LoadingPage